import styled from 'styled-components'
import { BiChevronDown } from 'react-icons/bi'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'

export const StoryMenu = ({
  elementsRefs,
  elements,
  color,
}: {
  elementsRefs: any
  elements: string[]
  color?: string
}) => {
  return (
    <Container>
      <TextWidth>
        <Content>
          {/* <Title>Sommaire</Title> */}
          <Elements>
          {elements.map((element, index) => (
            <Element
              onClick={() => {
                elementsRefs[index].scrollIntoView({ behavior: 'smooth' })
              }}
              key={index}
            >
              <Text color={color}>{element}</Text>
              <Icon color={color}>
                <BiChevronDown />
              </Icon>
            </Element>
          ))}
          </Elements>
        </Content>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  font-family: var(--font-sans-serif);
  counter-reset: section;
  // background: ${({ theme }) => theme.grayLight};
  padding: 1em 0;
  margin-bottom: 20px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1.1em;
  }
`

const Content = styled.div`
  //background: ${({ theme }) => theme.colorMode === 'dark' ? '#222222' : '#ffffff'};
  //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  //border-radius: 20px;
  //padding: 0px 20px;
  padding-top: 10px;
`

const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  margin-bottom: 1em;
`

const Icon = styled.div<{ color?: string }>`
  color: ${({ theme, color }) => color ? color : theme.tenantColor};
  transition: transform 0.3s ease;
`

const Text = styled.div<{ color?: string }>`
  font-weight: 400;
  line-height: 1.2;
  display: grid;
  grid-template-columns: min-content 1fr;

  &:before {
    font-weight: 700;
    margin-right: 1em;
    content: counter(section);
    color:  ${({ theme, color }) => color ? color : theme.tenantColor};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`

const Element = styled.div`
  cursor: pointer;
  padding: 0.75em 0;
  border-bottom: 1px solid
    ${({ theme }) => theme.grayDark};
  counter-increment: section;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.textColor};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    opacity: 0.85;

    ${Text} {
      font-weight: 700;
    }

    ${Icon} {
      transform: translateY(6px);
    }
  }
`

const Elements = styled.div`
`

export default StoryMenu
